module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hErfd"))).then(() => parcelRequire('dJXJK'));